export const getEnvAppPrefix = (env: string): string => {
  if (env === 'prod') {
    return `https://go.finverse.com/app/`;
  } else {
    return `https://go.${env}.finverse.net/app/`;
  }
};
